module.exports = __webpack_public_path__ + "static/media/kn.8d2a2bac.svg";